var map = {
	"./american-g.png": "9abO",
	"./american.png": "8JF4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "NeRQ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pay ^\.\/american.*\.png$
// module id = NeRQ
// module chunks = 1